/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftCircle = createReactComponent(
  "arrow-left-circle",
  "IconArrowLeftCircle",
  [
    ["path", { d: "M17 12h-14", key: "svg-0" }],
    ["path", { d: "M6 9l-3 3l3 3", key: "svg-1" }],
    ["path", { d: "M19 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-2" }]
  ]
);

export { IconArrowLeftCircle as default };
//# sourceMappingURL=IconArrowLeftCircle.js.map
